import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { PrivateRoute } from './components/PrivateRoute';
import { Header } from './components/Header';
import { Dashboard } from './pages/Dashboard';
import { AdminPanel } from './pages/AdminPanel';
import '@aws-amplify/ui-react/styles.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="app">
            <Authenticator
              hideSignUp={true}
              loginMechanisms={['email']}
              components={{
                SignIn: {
                  Header() {
                    return null;
                  },
                  Footer() {
                    return null;
                  }
                }
              }}
            >
              {({ signOut, user }) => (
                <>
                  <Header />
                  <nav className="nav">
                    <Link to="/" className="nav-link">Dashboard</Link>
                    <Link to="/admin" className="nav-link">Admin Panel</Link>
                  </nav>
                  
                  <main className="main-content">
                    <Routes>
                      <Route path="/" element={
                        <PrivateRoute>
                          <Dashboard />
                        </PrivateRoute>
                      } />
                      
                      <Route path="/admin" element={
                        <PrivateRoute requireAdmin={true}>
                          <AdminPanel />
                        </PrivateRoute>
                      } />
                      
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                </>
              )}
            </Authenticator>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
